import styled from 'styled-components';

export const Main = styled.main`
  flex: 1;
  display: flex;
`;
